import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import ApiDocsPage from './ApiDocsPage';
import './App.css';
import DocsPage from './DocsPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/docs" replace />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/docs/:section" element={<DocsPage />} />
            <Route path="/docs/:section/:page" element={<DocsPage />} />
            <Route path="/api-docs" element={<ApiDocsPage />} />
            <Route path="/api-docs/:section" element={<ApiDocsPage />} />
            <Route path="/api-docs/:section/:page" element={<ApiDocsPage />} />
            <Route path="/:section" element={<ApiDocsPage />} />
            <Route path="/:section/:page" element={<ApiDocsPage />} />
          </Routes>
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
